import { useEffect } from 'react';
const PageTitle = ({ title = 'Play Online Games for Cash' }) => {
    useEffect(() => {
        document.title = `Repeat - ${title}`;
    }, [title]);
    return null;
};
export default PageTitle;
